<template>
  <form id="create_transaction_form">
    <div class="card card-custom gutter-b">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label">افزودن تراکنش دستی</h3>
        </div>
      </div>
      <div class="card-body">
        <div class="form-group">
          <label>مقدار (تومان)</label>
          <the-mask
            mask="NPP,PPP,PPP,PPP"
            v-model="form.value"
            :tokens="maskTokens"
            :masked="true"
            name="value"
            ref="value"
            class="form-control form-control-solid"
            dir="ltr"
            autocomplete="off"
          ></the-mask>
        </div>
        <div class="form-group">
          <label>توضیحات</label>
          <textarea v-model="form.description" class="form-control"></textarea>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import { mapGetters } from "vuex";
import { STORE_ADMIN_TRANSACTION } from "@/core/services/store/admin/transactions.module";
import { TheMask } from "vue-the-mask";

export default {
  name: "transactions-create",
  data() {
    return {
      form: {
        value: "",
        description: ""
      }
    };
  },
  components: {
    TheMask
  },
  mounted() {
    this.setBreadcrumbs();
    this.setActions();

    this.eventHub.$on("save-transaction-event", this.save);

    this.fv = formValidation(
      document.getElementById("create_transaction_form"),
      {
        fields: {
          value: {
            validators: {
              notEmpty: {
                message: "مفدار الزامی است"
              }
            }
          }
        },
        plugins: {
          trigger: new Trigger(),
          bootstrap: new Bootstrap()
        }
      }
    );
  },
  beforeDestroy() {
    this.eventHub.$off("save-transaction-event");
    document.getElementById("save-transaction-btn").disabled = false;
  },
  computed: {
    ...mapGetters(["currentUserProperty", "transaction"])
  },
  methods: {
    setBreadcrumbs() {
      let items = [];

      items.push({
        title: "مدیریت",
        route: { name: "admin-dashboard" }
      });

      items.push({ title: "کاربران", route: { name: "admin-users-show" } });

      items.push({
        title: this.$route.params.id,
        route: {
          name: "admin-users-show",
          params: { id: this.$route.params.id }
        }
      });

      items.push({ title: "افزودن تراکنش" });

      this.$store.dispatch(SET_BREADCRUMB, items);
    },
    setActions() {
      this.$store.dispatch(SET_ACTIONS, {
        buttons: [
          {
            name: "ذخیره",
            event: "save-transaction-event",
            class: "btn-primary",
            id: "save-transaction-btn"
          }
        ],
        links: [
          {
            name: "بازگشت",
            to: {
              name: "admin-users-show",
              params: { id: this.$route.params.id }
            }
          }
        ]
      });
    },
    save() {
      this.fv.validate().then(status => {
        if (status === "Valid") {
          let submitBtn = document.getElementById("save-transaction-btn");
          this.disableBtn(submitBtn);

          this.$store
            .dispatch(STORE_ADMIN_TRANSACTION, {
              user: this.$route.params.id,
              value: this.parseNumbers(this.form.value) * 10,
              description: this.form.description
            })
            .then(() => {
              this.$router.push({
                name: "admin-users-show",
                params: { id: this.$route.params.id }
              });
            })
            .catch(() => {
              this.enableBtn(submitBtn);
            });
        } else if (status === "Invalid") {
          this.showError("لطفا فرم را به شکل صحیح کامل کنید");
        }
      });
    }
  }
};
</script>
